var path = '/app/pages/montanha/montanha.html';
var html = "<section> <nav class=intro-buttons> <a ng-click=$ctrl.gameSound() class=btn-sound></a> <a ng-click=$ctrl.showHelp() class=btn-help></a> </nav> <div id=stones-altar> <div ng-repeat=\"stone in $ctrl.altarStones track by $index\" ui-on-drop=\"$ctrl.dropStone($index, $data)\" id=\"{{ stone.nome }}\" class=stone style=background-image:url({{stone.bg}})></div> </div> <div id=stones-box> <img class=stone ng-repeat=\"stone in $ctrl.boxStones\" ng-src={{stone.src}} ui-draggable=true id=green drag=\"{ data: stone }\" ng-show=stone.visible> </div> </section> <section id=help ng-show=$ctrl.showHelpTab ng-click=$ctrl.showHelp()></section>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/montanha/montanha.html
// module id = 171
// module chunks = 0